import { render, staticRenderFns } from "./ProductMaterialCostTab.vue?vue&type=template&id=f3e47e14&"
import script from "./ProductMaterialCostTab.vue?vue&type=script&lang=js&"
export * from "./ProductMaterialCostTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports